module.exports = __webpack_public_path__ + "img/decrement_arrow.f37f8fed.svg";